module.exports = __webpack_public_path__ + "assets/img/2016_2.59f5820e.png";